import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoLight from '../assets/images/logo-light.png'

const Ragister = () => {
  const [dataBlock] = useState({
    title: "Signup Now!",
    subTitle:
      "Registration takes less than a minute but gives you full control over your orders.",
  });
  return (
    <>
      <section className="items-center flex bg-[url('../images/login_bg.jpg')] bg-cover bg-center relative py-20 min-h-screen">
        <div className="bg-[#0d0f14]/25 absolute inset-0 backdrop-blur-md"></div>
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="max-w-[450px] mx-auto">
              <Link to="/landing/">
                <img
                  src={logoLight}
                  alt="logo"
                  className="mx-auto h-10"
                />
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 mt-16">
            <div className="max-w-[450px] mx-auto py-10 px-8 rounded-xl bg-white w-full">
              <h4 className="font-bold text-2xl mb-2 text-center capitalize">
                {dataBlock.title}
              </h4>
              <p className="text-muted text-center">{dataBlock.subTitle}</p>
              <form className="mt-6 space-y-4">
                <div>
                  <label className="font-bold">First Name</label>
                  <input
                    type="text"
                    className="form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom"
                    placeholder="First Name"
                  />
                </div>
                <div>
                  <label className="font-bold">Email Address</label>
                  <input
                    type="text"
                    className="form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom"
                    placeholder="Email Id"
                  />
                </div>
                <div>
                  <label className="font-bold">Password</label>
                  <input
                    type="password"
                    className="form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom"
                    placeholder="Password"
                  />
                </div>
                <div>
                  <input
                    type="checkbox"
                    className="form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom"
                    id="sign"
                  />
                  <label htmlFor="sign" className="ml-1 relative top-[2px]">
                    I agree to the{" "}
                    <a href="#" className="text-custom">
                      Terams & Conditions
                    </a>
                  </label>
                </div>
                <div>
                  <button type="submit" className="btn-custom w-full">
                    Sign In
                  </button>
                </div>
              </form>
            </div>
            <div className="text-center mt-6">
              <p>
                <small className="text-white mr-2">Already have an account?</small>
                <Link to="/account/" className="text-white font-bold">
                  Sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ragister;
